/**
 * Labstep
 */

import { EntityActionUpdateAllowedActionsLockContent as Content } from 'labstep-web/components/Entity/Action/Update/AllowedActionsLock/Content';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { IEntityActionUpdateEntityActionUpdateAllowedActionsLockTableProps } from './types';

export const EntityActionUpdateAllowedActionsLock: React.FC<
  IEntityActionUpdateEntityActionUpdateAllowedActionsLockTableProps
> = ({ entity }) => (
  <ModalDefault
    size="large"
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        dataCy="components/Entity/Action/Update/AllowedActionsLock:action"
        type="option"
        onClick={toggleModal}
        text="Settings"
        icon="cog"
      />
    )}
    showDone
    content={<Content entity={entity} />}
    header={`${getHumanReadableEntityName(
      entity.entityName,
      false,
      true,
    )} Settings`}
  />
);
